import { forwardRef, useEffect, useImperativeHandle, useState } from "react";
import CryptoJS from "crypto-js";
import { Box, HStack, Spinner, Text, VStack, useMediaQuery } from "native-base";
import NoDataFound from "../../components/noDataFound";
import BarCharts from "./barChart";
import PieCharts from "./pieChart";
import { getMISGraphAPI, getMISMICEGraphAPI } from "../../api/apis/graphs";
import { Toaster } from "../../components/toaster";
import ContainerCards from "../../components/cards";
import { COLORS } from "../../utils/colors";
import { COMMONFONTSIZE, COMMONFONTWEIGHT } from "../../utils/fonts";
import { MOBILE_VIEW_WIDTH } from "../../utils/screens";
import { EventChartTable, MICEChartTable } from "./table";
import { hasPermission } from "../../utils/permission";
import config from "../../utils/config";

const Charts = forwardRef(({ activeTab, date }, ref) => {
  const toaster = Toaster();
  const [data, setData] = useState([]);
  const [MobileWindow] = useMediaQuery({
    maxWidth: MOBILE_VIEW_WIDTH,
  });
  const bytes = CryptoJS.AES.decrypt(
    sessionStorage.getItem("content"),
    config.userKey
  );
  const jsonString = bytes.toString(CryptoJS.enc.Utf8);
  const userInfo = JSON.parse(jsonString);
  const [noData, setNoData] = useState(true);
  const [isLoading, setIsLoading] = useState(true);
  const [cardDate, setCardDate] = useState([]);

  useEffect(() => {
    setData([]);
    setNoData(true);
    const getDateChange = () => {
      const currentDate = new Date();
      const year = currentDate.getFullYear();
      const month = (currentDate.getMonth() + 1).toString().padStart(2, "0");
      const day = currentDate.getDate().toString().padStart(2, "0");
      return `${year}-${month}-${day}`;
    };
    setCardDate(formatDateRange(date.from_date, date.to_date));
    activeTab === "event" && getEventsGraphsAPI("2020-01-01", getDateChange());
    activeTab === "mice" && getMICEGraphs("2020-01-01", getDateChange());
  }, [activeTab]);

  const getEventsGraphsAPI = async (
    fromDate = date.from_date,
    toDate = date.to_date
  ) => {
    setIsLoading(true);
    setData([]);
    setNoData(false);

    let email = "";
    if (hasPermission("ALL_DASHBOARD")) {
      email = userInfo.email;
    }

    let res = await getMISGraphAPI(fromDate, toDate, email);
    if (res.error) {
      toaster(res.message, "error", "error");
      return [];
    } else {
      let final = [];
      res.data?.data?.data?.forEach((obj) => {
        if (obj instanceof Array) {
          obj && obj.length === 0 && setNoData(true);
        } else {
          const Key = Object.keys(obj)[0];
          const value = obj[Key][0];
          const value1 = obj[Key][1];
          if (
            (value1 && value1.length === 0) ||
            (value && value.length === 0)
          ) {
            setNoData(true);
          }
        }
      });
      res.data?.data?.data?.map((item) => {
        let result = {};
        let title = "",
          labels,
          values = [],
          type = "",
          view;

        if (item instanceof Array) {
          const formattedData =
            item && item[0] && item[0].table_data
              ? item[0].table_data.map((dataItem) => {
                  type = dataItem.type;
                  title = dataItem.title;
                  const companyName = dataItem["Aditya Birla Group Company"];
                  const agencies =
                    dataItem.agencies &&
                    dataItem.agencies.map((agency) => ({
                      name: agency.name,
                      totalBilling: agency.total_billing,
                    }));
                  return { companyName, agencies };
                })
              : [];
          result = {
            title: title,
            labels: "",
            values: formattedData,
            type: type,
            view: "table",
          };
          final.push(result);
        } else {
          Object.keys(item)?.forEach((key) => {
            if (key !== "type" && key !== "view") {
              title = key;
              labels = item[key][0];
              values.push({
                label: item[key][0],
                data: item[key][1],
                backgroundColor:
                  item.view === "chart"
                    ? [
                        "#6ccbf1",
                        "#3884c5",
                        "#5acfa3",
                        "#3f936b",
                        "#54ae50",
                        "#9dcf3b",
                        "#2b8db8",
                        "",
                        "",
                        "",
                        "",
                      ]
                    : "#6ccbf1",
                borderColor: item.view === "chart" ? ["#fff"] : "#6ccbf1",
                borderWidth: item.view === "chart" ? 1.5 : 1,
              });
            } else {
              if (key === "type") {
                type = item[key];
              } else if (key === "view") {
                view = item[key];
              }
            }
          });
          result = {
            title: title,
            labels: labels,
            values: values,
            type: type,
            view: view,
          };
          final.push(result);
        }
      });
      setData(final);
    }
    setIsLoading(false);
  };

  const getMICEGraphs = async (
    fromDate = date.from_date,
    toDate = date.to_date
  ) => {
    setIsLoading(true);
    setData([]);
    setNoData(false);

    let email = "";
    if (hasPermission("ALL_DASHBOARD")) {
      email = userInfo.email;
    }

    let res = await getMISMICEGraphAPI(fromDate, toDate, email);
    if (res.error) {
      toaster(res.message, "error", "error");
      return [];
    } else {
      let final = [];
      res.data?.data?.data?.forEach((obj) => {
        if (obj instanceof Array) {
          obj && obj.length === 0 && setNoData(true);
        } else {
          const Key = Object.keys(obj)[0];
          const value = obj[Key][0];
          const value1 = obj[Key][1];
          if (
            (value1 && value1.length === 0) ||
            (value && value.length === 0)
          ) {
            setNoData(true);
          }
        }
      });
      res.data?.data?.data?.map((item) => {
        let result = {};
        let title = "",
          labels,
          values = [],
          type = "",
          view;

        if (item instanceof Array) {
          const formattedData =
            item && item[0] && item[0].table_data
              ? item[0].table_data
                  .map((dataItem) => {
                    type = dataItem.type;
                    title = dataItem.title;
                    const companyName = dataItem["Aditya Birla Group Company"];
                    const agencies =
                      dataItem.agencies &&
                      dataItem.agencies.map((agency) => ({
                        name: agency.name,
                        totalBilling: agency.total_billing,
                      }));
                    return { companyName, agencies };
                  })
                  .sort((a, b) => {
                    if (a.companyName < b.companyName) {
                      return -1;
                    }
                    if (a.companyName > b.companyName) {
                      return 1;
                    }
                    return 0;
                  })
              : [];
          result = {
            title: title,
            labels: "",
            values: formattedData,
            type: type,
            view: "table",
          };
          final.push(result);
        } else {
          Object.keys(item)?.forEach((key) => {
            if (key !== "type" && key !== "view") {
              title = key;
              labels = item[key][0].map(val => val === null ? "-" : val);
              values.push({
                label: item[key][0],
                data: item[key][1],
                backgroundColor:
                  item.view === "chart"
                    ? [
                        "#93bd19",
                        "#5c9c1b",
                        "#e1b600",
                        "#dd6500",
                        "#bb3000",
                        "#8f8252",
                        "#587111",
                        "#365d0f",
                        "#886d00",
                        "#853c00",
                        "",
                      ]
                    : "#96c01b",
                borderColor: item.view === "chart" ? ["#fff"] : "#96c01b",
                borderWidth: item.view === "chart" ? 1.5 : 1,
              });
            } else {
              if (key === "type") {
                type = item[key];
              } else if (key === "view") {
                view = item[key];
              }
            }
          });
          result = {
            title: title,
            labels: labels,
            values: values,
            type: type,
            view: view,
          };
          final.push(result);
        }
      });
      setData(final);
    }
    setIsLoading(false);
  };

  const formatDateRange = (fromDate, toDate) => {
    const monthNames = [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December",
    ];
    const from = new Date(fromDate);
    const to = new Date(toDate);
    setCardDate(
      `${monthNames[from.getMonth()]} ${from.getFullYear()} - ${
        monthNames[to.getMonth()]
      } ${to.getFullYear()}`
    );
    return `${monthNames[from.getMonth()]} ${from.getFullYear()} - ${
      monthNames[to.getMonth()]
    } ${to.getFullYear()}`;
  };

  useImperativeHandle(ref, () => ({
    getEventsGraphsAPI,
    getMICEGraphs,
    formatDateRange,
  }));

  return (
    <>
      {isLoading ? (
        <Box
          mt={5}
          mb={10}
          flex={1}
          alignItems="center"
          justifyContent="center"
        >
          <Spinner color={COLORS.THEME_COLOR} size="lg" />
        </Box>
      ) : (
        <HStack
          flexWrap={"wrap"}
          width={"100%"}
          justifyContent={"space-between"}
        >
          {noData ? (
            <NoDataFound dataName="data" />
          ) : (
            data?.map((item) => {
              let horizontal = false;
              if (item.title === "Top 10 Destination Used In Value") {
                horizontal = true;
              }
              return item.view === "graph" ? (
                <Box
                  width={MobileWindow ? "100%" : "100%"}
                  mb={5}
                  display={"flex"}
                >
                  <ContainerCards
                    background={COLORS.WHITE_COLOR}
                    boxShadow="0px 18.953px 47.382px 0px rgba(119, 115, 170, 0.10)"
                    height={"100%"}
                    width="100%"
                    flex={1}
                  >
                    <Box p={5} pb={10} width={"100%"}>
                      <VStack>
                        <HStack
                          justifyContent={"space-between"}
                          width={"100%"}
                          alignItems={"center"}
                        >
                          <Text
                            fontSize={COMMONFONTSIZE.EXTRA_LARGE_FONT_SIZE}
                            fontWeight={
                              COMMONFONTWEIGHT.MEDIUM_LARGE_FONT_WEIGHT
                            }
                          >
                            {item.title}
                          </Text>
                          <Text fontSize={COMMONFONTSIZE.MEDIUM_FONT_SIZE}>
                            {item.type}
                          </Text>
                        </HStack>
                        <Text
                          mt={1}
                          fontSize={COMMONFONTSIZE.MEDIUM_FONT_SIZE}
                          color={COLORS.GRAPH_DATE_COLOR}
                          fontStyle="italic"
                        >
                          {date?.from_date && date?.to_date && cardDate}
                        </Text>
                      </VStack>
                      <Box
                        justifyContent={"center"}
                        alignItems={"center"}
                        mt={5}
                      >
                        <BarCharts
                          horizontal={horizontal}
                          activeTab={activeTab}
                          labels={item.labels}
                          data={item.values}
                        />
                      </Box>
                    </Box>
                  </ContainerCards>
                </Box>
              ) : item.view === "chart" ? (
                <Box
                  width={MobileWindow ? "100%" : "100%"}
                  mb={5}
                  display={"flex"}
                  flexDirection="column"
                >
                  <ContainerCards
                    background={COLORS.WHITE_COLOR}
                    boxShadow="0px 18.953px 47.382px 0px rgba(119, 115, 170, 0.10)"
                    height={"100%"}
                    width="100%"
                    flex={1}
                  >
                    <Box p={5} pb={10} width={"100%"}>
                      <VStack>
                        <HStack
                          justifyContent={"space-between"}
                          width={"100%"}
                          alignItems={"center"}
                        >
                          <Text
                            fontSize={COMMONFONTSIZE.EXTRA_LARGE_FONT_SIZE}
                            fontWeight={
                              COMMONFONTWEIGHT.MEDIUM_LARGE_FONT_WEIGHT
                            }
                          >
                            {item.title}
                          </Text>
                          <Text fontSize={COMMONFONTSIZE.MEDIUM_FONT_SIZE}>
                            {item.type}
                          </Text>
                        </HStack>
                        <Text
                          mt={1}
                          fontSize={COMMONFONTSIZE.MEDIUM_FONT_SIZE}
                          color={COLORS.GRAPH_DATE_COLOR}
                          fontStyle="italic"
                        >
                          {date?.from_date && date?.to_date && cardDate}
                        </Text>
                      </VStack>
                      <Box
                        justifyContent={"center"}
                        alignItems={"center"}
                        pt={"40px"}
                        width={"100%"}
                      >
                        <PieCharts
                          activeTab={activeTab}
                          labels={item.labels}
                          data={item.values}
                        />
                      </Box>
                    </Box>
                  </ContainerCards>
                </Box>
              ) : (
                item.view === "table" && (
                  <Box
                    width={"100%"}
                    mb={5}
                    display={"flex"}
                    flexDirection="column"
                  >
                    <ContainerCards
                      background={COLORS.WHITE_COLOR}
                      boxShadow="0px 18.953px 47.382px 0px rgba(119, 115, 170, 0.10)"
                      height={"100%"}
                      width="100%"
                      flex={1}
                    >
                      <Box p={5} pb={10} width={"100%"}>
                        <VStack>
                          <HStack
                            justifyContent={"space-between"}
                            width={"100%"}
                            alignItems={"center"}
                          >
                            <Text
                              fontSize={COMMONFONTSIZE.EXTRA_LARGE_FONT_SIZE}
                              fontWeight={
                                COMMONFONTWEIGHT.MEDIUM_LARGE_FONT_WEIGHT
                              }
                            >
                              {item.title}
                            </Text>
                            <Text fontSize={COMMONFONTSIZE.MEDIUM_FONT_SIZE}>
                              {item.type}
                            </Text>
                          </HStack>
                          <Text
                            mt={1}
                            fontSize={COMMONFONTSIZE.MEDIUM_FONT_SIZE}
                            color={COLORS.GRAPH_DATE_COLOR}
                            fontStyle="italic"
                          >
                            {date?.from_date && date?.to_date && cardDate}
                          </Text>
                        </VStack>
                        <Box
                          justifyContent={"center"}
                          alignItems={"center"}
                          pt={"40px"}
                          width={"100%"}
                        >
                          {item &&
                            item.values &&
                            (activeTab === "mice" ? (
                              <MICEChartTable
                                data={item.values}
                                activeTab={activeTab}
                              />
                            ) : (
                              <EventChartTable
                                data={item.values}
                                activeTab={activeTab}
                              />
                            ))}
                        </Box>
                      </Box>
                    </ContainerCards>
                  </Box>
                )
              );
            })
          )}
        </HStack>
      )}
    </>
  );
});

export default Charts;
